<template>
<div class="html main-purchase">
  <div class="body">
    <!-- <body> -->
    <div class="main">
      <div class="mcontainer" className="container">
        <header>
          <h1>{{productTitle}}</h1>
          <!-- <p>You are securing an ACO slot for the {{productTitle}}.</p> -->
          <p>Your card won't be charged till after success.</p>
          <!-- <p>Use <code>4242 4242 4242 4242</code> and any CVC and future expiration date</p> -->
        </header>

        <b-btn size="md" pill v-b-modal.acoModal variant="info" style="">Set ACO Details</b-btn>
        <AddressModal/>
        <form @submit.prevent="handleSubmit" id="card-form" class="form-container">
          <div class="group">
            <label>
              <span>Name</span>
              <input v-model="stripeForm.name" name="cardholder-name" class="field" required placeholder="Jane Doe" />
            </label>
            <label>
              <span>Email</span>
              <input required v-model="stripeForm.email" class="field" name="email" placeholder="youremail@domain.com" type="email" />
            </label>
            <!-- <label>
              <span>Phone</span>
              <input v-model="stripeForm.phone" class="field" name="telephone" placeholder="(123) 456-7890" type="tel" />
            </label> -->
          </div>
          <div class="group">
            <label>
              <span>Card</span>
              <div id="card-element" class="field"></div>
            </label>
          </div>
          <button class="mybutton" type="submit">Pay ${{selectedPrice}}</button>
          <div class="outcome">
            <div class="error"></div>
            <div class="successPurchase" style="">
              Your slot has been purchased! Redirecting you in {{secondsLeft}}.
            </div>
            <div class="success">
              <!-- Your c -->
              <!-- Success! Your Stripe token is <span class="token"></span> -->
            </div>
          </div>
        </form>
        <!-- <footer>
        <p>
          Made by <a href="https://twnsnd.co">Cole Townsend</a>
        </p>
        <p>
          Read the blog post on <a href="https://hackernoon.com/accept-payments-on-your-site-with-nextjs-stripe-and-micro-371de95b22d5">Medium</a>
        </p>
      </footer> -->
      </div>
    </div> <!-- main -->
  </div> <!-- body -->
</div> <!-- html -->
</template>

<script>
import AddressModal from '@/components/AcoModal'
import router from '@/router'
import {productService} from '@/services/product'

import config from '@/config'
var stripe = Stripe(config.stripeKey)
var elements = stripe.elements();
var card

function setOutcome(result) {
  // console.log('setOutcome called', result)
  var successElement = document.querySelector('.success');
  var errorElement = document.querySelector('.error');
  successElement.classList.remove('visible');
  errorElement.classList.remove('visible');

  if (result.token) {
    var tokenId = result.token.id
    console.log(`stripe token ${result.token.id} created`)
    // Use the token to create a charge or a customer
    // https://stripe.com/docs/charges
    // var token = result.token.id
    // $('form').append($('<input type="hidden" name="stripeToken">').val(token));
    // successElement.querySelector('.token').textContent = result.token.id;
    // successElement.classList.add('visible');
    return result.token;
  } else if (result.error) {
    errorElement.textContent = result.error.message;
    errorElement.classList.add('visible');
  }
}
import testProfile from '@/helpers/testProfile'
import { checkoutService } from '@/services/checkout'

export default {
  name: 'purchase',
  components: {
    AddressModal
  },
  data() {
    return {
      products: [{
          title: '',

        }

      ],
      secondsLeft: 5,
      productTitle: 'Supreme Acesss Auto Checkout',
      price: .10,
      testProductId: "", //'trqjP0Xkx',
      stripeForm: {
        name: '',
        email: '',
        phone: '',
      }
    }
  },
  computed: {


    selectedPrice() {
      let productId
      if(this.acoData && this.acoData.productForm && this.acoData.productForm.id) {
        productId = productId
      } else if (this.$route.query.productId){
        productId = this.$route.query.productId

      }
    if(!productId) return .1
    let product = this.products.find(p=> p.productId == productId)
    if(!product || !product.price) return .1
    return product.price
    },

    acoData() {
      return this.$store.state.orders.aco
    }
  },
  created() {
    this.getProducts()
  },
  methods: {

    getProducts() {
      productService.getAvailProducts()
      .then((resp) => {
        this.products = resp
      })
      .catch(console.error)
    },

    setError(message) {
      var errorElement = document.querySelector('.error');
      errorElement.textContent = message
      errorElement.classList.add('visible');
    },
    clearError() {
      var errorElement = document.querySelector('.error');
      errorElement.classList.remove('visible');

    },
    testPurchase(stripeToken) {
      console.log(`purchase fn called with token`, stripeToken)
      let { name, email } = this.stripeForm
      console.log(`attempting to checkout for ${email} ${name} with token ${stripeToken.id}`)
      let payload = { name, email, stripeToken, acoData: testProfile, productId: this.testProductId }
      console.log(`submitting payment payload`, payload)
      checkoutService.checkout(payload)
        .then(console.log)
        .catch(console.error)
    },
    purchase(stripeToken) {
      console.log(`purchase fn called with token`, stripeToken)
      let { name, email } = this.stripeForm
      console.log(`attempting to checkout for ${email} ${name} with token ${stripeToken.id}`)
      let {acoData}  = this
      let {productForm} = acoData
      let {id,size,style} = productForm

      let payload = { name, email, stripeToken, acoData: this.acoData, productId: id, size: size,style:style }
      console.log(`submitting payment payload`, payload)
      checkoutService.checkout(payload)
        .then((res) => {
          console.log(res)

          var xsuccessElement = document.querySelector('.successPurchase');
          xsuccessElement.classList.add('visible')
          this.dashboardRedirect()
        })
        .catch(console.error)
    },
    dashboardRedirect() {
      let secondsLeft = 5
      this.secondsLeft = 5
      let interval = setInterval(() => {
        this.secondsLeft -= 1
        if(this.secondsLeft == 0) {
          router.push('/dashboard')
        }
      },1000)
    },
    validatePage() {
      let validACO = this.verifyAcoData()
      if (!validACO) return 'Invalid ACO Information. Please set your ACO details.'
      let { stripeForm } = this
      if (!stripeForm.email) return 'Email is required.'
      if (!stripeForm.name) return 'Name is required.'


    },
    validateAddress(a) {
      console.log(`validating address`,a)
      if (!a.firstName || !a.lastName || !a.address1 || !a.zip || !a.city) return false
      return true
    },
    verifyAcoData() {
      console.log(this.acoData)
      // return true
      if (!this.acoData) {
        console.error('invalid aco data')
        return false
      }
      let { billing, shipping, card, email, phone, matchInfo } = this.acoData
      if (!this.validateAddress(shipping)) {
        console.error('invalid address')
        return false
      }
      if (!email || !phone) {
        console.error('invalid email or phone #')
        return false
      }
      return true
    },
    async handleSubmit(e) {
      e.preventDefault();
      let validPageError = this.validatePage()
      if (validPageError) {
        console.log(`validatePage has error ${validPageError}`)
        return this.setError(validPageError)
      }
      var form = document.querySelector('form');
      var extraDetails = {
        name: form.querySelector('input[name=cardholder-name]').value
      };
      // console.log(extraDetails)
      let result = await stripe.createToken(card, extraDetails)
      let token = setOutcome(result)
      this.purchase(token)
      // stripe.createToken(card, extraDetails).then(setOutcome).then(function(res) {
      // this.purchase(res)
      // })
    }
  },
  mounted() {

    card = elements.create('card', {
      style: {
        base: {
          iconColor: '#666EE8',
          color: '#31325F',
          lineHeight: '40px',
          fontWeight: 400,
          fontFamily: '-apple-system, BlinkMacSystemFont, Roboto',
          fontSize: '15px',
          fontSmoothing: 'antialiased',

          '::placeholder': {
            color: '#CFD7E0',
          },
        },
      }
    });
    card.mount('#card-element');




    card.on('change', function(event) {
      setOutcome(event);
    });

  },

}
</script>


<style scoped>
* {
  /* font-size: 15px; */
  /* font-variant: normal; */
  /* padding: 0;
  margin: 0; */
}

.html {
  height: 100%;
  background-color: #dbdbdb;
  /* background-color: #4a4a4a; */
}

.body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol" !important;
  /* background: #F6F8FA; */
  background: #dbdbdb;
  color: #4C555A;
  min-height: 100%;
  -webkit-font-smoothing: antialiased;
}

.main {
  -ms-align-items: center;
  align-items: flex-start;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  height: 100vh;
  justify-content: center;
}

.container {
  max-width: 720px;
  padding: 100px 0;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -moz-flex-direction: column;
  -ms-flex-direction: column;
  -o-flex-direction: column;
  flex-direction: column;
}

.mcontainer {
  max-width: 720px;
  min-width: 400px;
  padding: 50px 0;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -moz-flex-direction: column;
  -ms-flex-direction: column;
  -o-flex-direction: column;
  flex-direction: column;
}


header {
  padding-bottom: 2rem;
  text-align: center;
}

h1 {
  margin-bottom: 0.75rem;
}

p>code {
  padding: 5px 8px;
  border-radius: 3px;
  background-color: #ffffff;
  color: #BBBFF4;
}

.form-container {
  display: block;
}

footer {
  width: 100%;
  padding-top: 1rem;
  text-align: center;
}

h1 {
  font-size: 24px;
  font-weight: 500;
  text-align: center;
}

form {
  /* max-width: 480px; */
  /* min-width: 300px; */
  width: 100%;
  margin: 20px 0;
}

footer {
  width: 100%;
  max-width: 480px;
  clear: both;
}

a {
  color: #424770;
  -webkit-transition: color .4s ease-in-out;
  -o-transition: color .4s ease-in-out;
  transition: color .4s ease-in-out;
}

a:visited {
  color: #6772E5;
}

a:hover {
  color: #24B47E;
  -webkit-transition: color .2s ease-in-out;
  -o-transition: color .2s ease-in-out;
  transition: color .2s ease-in-out;
}

.group {
  background: white;
  box-shadow: 0 7px 14px 0 rgba(49, 49, 93, 0.10),
    0 3px 6px 0 rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  margin-bottom: 20px;
}

label {
  position: relative;
  color: #8898AA;
  font-weight: 400;
  height: 40px;
  line-height: 40px;
  margin-left: 20px;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -moz-flex-direction: row;
  -ms-flex-direction: row;
  -o-flex-direction: row;
  flex-direction: row;
}

.group label:not(:last-child) {
  border-bottom: 1px solid #F0F5FA;
}

label>span {
  width: 80px;
  text-align: right;
  margin-right: 30px;
}

.field {
  background: transparent;
  font-weight: 400;
  border: 0;
  color: #31325F;
  outline: none;
  flex: 1;
  padding-right: 10px;
  padding-left: 10px;
  cursor: text;
}

.field::-webkit-input-placeholder {
  color: #CFD7E0;
}

.field::-moz-placeholder {
  color: #CFD7E0;
}

.mybutton {
  display: block;
  background: #666EE8;
  color: white;
  cursor: pointer;
  box-shadow: 0 7px 14px 0 rgba(49, 49, 93, 0.10),
    0 3px 6px 0 rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  border: 0;
  margin-top: 20px;
  font-size: 15px;
  font-weight: 500;
  width: 100%;
  height: 40px;
  line-height: 38px;
  outline: none;
}

button:focus {
  background: #555ABF;
}

button:active {
  background: #43458B;
}

.outcome {
  float: left;
  width: 100%;
  padding-top: 8px;
  min-height: 24px;
  text-align: center;
}

.success,
.error {
  display: none;
  font-size: 13px;
}

.successPurchase {
  display: none;
}

.success.visible,
.successPurchase.visible,
.error.visible {
  display: inline;
}

.error {
  color: #E4584C;
}

.success {
  color: #666EE8;
}

.success .token {
  font-weight: 500;
  font-size: 13px;
}
</style>
